import { __assign as s } from "./index11.js";
import D from "./index47.js";
import { gracefulDecodeURIComponent as E } from "./index74.js";
import { tld as K } from "./index48.js";
import { version as A } from "./index20.js";
import { UniversalStorage as y, getAvailableStorageOptions as L } from "./index17.js";
var f;
function M() {
  if (f)
    return f;
  var r = K(window.location.href);
  return f = {
    expires: 31536e6,
    secure: !1,
    path: "/"
  }, r && (f.domain = r), f;
}
var R = "npm";
function T() {
  return R;
}
function U() {
  var r = D.get("_ga");
  if (r && r.startsWith("amp"))
    return r;
}
function V(r) {
  return r.startsWith("?") && (r = r.substring(1)), r = r.replace(/\?/g, "&"), r.split("&").reduce(function(a, e) {
    var n = e.split("="), o = n[0], i = n[1], l = i === void 0 ? "" : i;
    if (o.includes("utm_") && o.length > 4) {
      var t = o.substr(4);
      t === "campaign" && (t = "name"), a[t] = E(l);
    }
    return a;
  }, {});
}
function F(r) {
  var a = {
    btid: "dataxu",
    urid: "millennial-media"
  };
  r.startsWith("?") && (r = r.substring(1)), r = r.replace(/\?/g, "&");
  for (var e = r.split("&"), n = 0, o = e; n < o.length; n++) {
    var i = o[n], l = i.split("="), t = l[0], v = l[1];
    if (a[t])
      return {
        id: v,
        type: a[t]
      };
  }
}
function G(r, a, e) {
  var n = new y(e ? [] : ["cookie"], L(M())), o = n.get("s:context.referrer"), i = F(r);
  i = i ?? o, i && (a && (a.referrer = s(s({}, a.referrer), i)), n.set("s:context.referrer", i));
}
function Z(r, a, e, n) {
  var o, i, l, t, v = r.user(), m = window.location.search;
  a.context = (i = (o = a.context) !== null && o !== void 0 ? o : a.options) !== null && i !== void 0 ? i : {};
  var d = a.context;
  delete a.options, a.writeKey = e?.apiKey, d.userAgent = window.navigator.userAgent;
  var h = navigator.userLanguage || navigator.language;
  if (typeof d.locale > "u" && typeof h < "u" && (d.locale = h), !d.library) {
    var z = T();
    z === "web" ? d.library = {
      name: "analytics.js",
      version: "next-".concat(A)
    } : d.library = {
      name: "analytics.js",
      version: "npm:next-".concat(A)
    };
  }
  m && !d.campaign && (d.campaign = V(m)), G(m, d, (l = r.options.disableClientPersistence) !== null && l !== void 0 ? l : !1), a.userId = a.userId || v.id(), a.anonymousId = a.anonymousId || v.anonymousId(), a.sentAt = /* @__PURE__ */ new Date();
  var I = r.queue.failedInitializations || [];
  I.length > 0 && (a._metadata = { failedInitializations: I });
  var p = [], c = [];
  for (var u in n) {
    var w = n[u];
    u === "Segment.io" && p.push(u), w.bundlingStatus === "bundled" && p.push(u), w.bundlingStatus === "unbundled" && c.push(u);
  }
  for (var g = 0, x = e?.unbundledIntegrations || []; g < x.length; g++) {
    var _ = x[g];
    c.includes(_) || c.push(_);
  }
  var O = (t = e?.maybeBundledConfigIds) !== null && t !== void 0 ? t : {}, C = [];
  p.sort().forEach(function(W) {
    var b;
    ((b = O[W]) !== null && b !== void 0 ? b : []).forEach(function(B) {
      C.push(B);
    });
  }), e?.addBundledMetadata !== !1 && (a._metadata = s(s({}, a._metadata), { bundled: p.sort(), unbundled: c.sort(), bundledIds: C }));
  var S = U();
  return S && (d.amp = { id: S }), a;
}
export {
  U as ampId,
  T as getVersionType,
  Z as normalize,
  V as utm
};
//# sourceMappingURL=index54.js.map
